import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=645644c4&scoped=true"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=645644c4&prod&scoped=true&lang=css"
import style1 from "./ReportTable.vue?vue&type=style&index=1&id=645644c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645644c4",
  null
  
)

export default component.exports